export const SUCCESS = {
    CREATE_VEHICLE_TYPE: 'Created vehicle type successfully',
    UPDATE_VEHICLE_TYPE: 'Updated vehicle type successfully',
    DELETE_VEHICLE_TYPE: 'Deleted vehicle type successfully',
    CREATE_BRANCH: 'Created branch successfully',
    UPDATE_BRANCH: 'Updated branch successfully',
    CREATE_POSTCODE: 'Created postcode successfully',
    UPDATE_POSTCODE: 'Updated postcode successfully',
    DELETE_POSTCODE: 'Deleted postcode successfully',

    CREATE_FAILURE_REASON: 'Created failure reason successfully',
    UPDATE_FAILURE_REASON: 'Updated failure reason successfully',
    DELETE_FAILURE_REASON: 'Deleted failure reason successfully',
    CREATE_SURCHARGE: 'Created surcharge successfully',
    UPDATE_SURCHARGE: 'Updated surcharge successfully',
    DELETE_SURCHARGE: 'Deleted surcharge successfully',
    CREATE_EXCEPTION_CODE: 'Created exception code successfully',
    UPDATE_EXCEPTION_CODE: 'Updated exception code successfully',
    DELETE_EXCEPTION_CODE: 'Deleted exception code successfully',
    CREATE_USER: 'Created user successfully',
    UPDATE_USER: 'Updated user successfully',
    DELETE_USER: 'Deleted user successfully',
    UPDATE_PASSWORD_USER: 'Updated password user successfully',
    CREATE_SUBCONTRACTOR: 'Created subcontractor successfully',
    CREATE_SUBCONTRACTOR_XERO: 'Created subcontractor xero successfully',
    UPDATE_SUBCONTRACTOR: 'Updated subcontractor successfully',
    DELETE_SUBCONTRACTOR: 'Deleted subcontractor successfully',
    CREATE_SUBCONTRACTOR_NOTE: 'Created subcontractor note successfully',
    CREATE_ADDRESS_BOOK: 'Created address book successfully',
    UPDATE_ADDRESS_BOOK: 'Updated address book successfully',
    DELETE_ADDRESS_BOOK: 'Deleted address book successfully',
    CREATE_TARIFF: 'Created tariff successfully',
    UPDATE_TARIFF: 'Updated tariff successfully',
    DELETE_TARIFF: 'Deleted tariff successfully',
    CREATE_SUPPLIER: 'Created supplier successfully',
    UPDATE_SUPPLIER: 'Updated supplier successfully',
    DELETE_SUPPLIER: 'Deleted supplier successfully',
    CREATE_CUSTOMER: 'Created customer successfully',
    UPDATE_CUSTOMER: 'Updated customer successfully',
    DELETE_CUSTOMER: 'Deleted customer successfully',
    CREATE_QUOTATION: 'Created quotation successfully',
    DELETE_QUOTATION: 'Deleted quotation successfully',
    CONVERT_QUOTATION: 'Quotation Successfully Converted',
    ADD_SUPPLIER_CUSTOMER: 'Added supplier customer successfully',
    ADD_VEHICLETYPE_CUSTOMER: 'Added customer vehicletype successfully',

    CREATE_CONSIGNMENT: 'Created consignment successfully',
    UPDATE_CONSIGNMENT: 'Updated consignment successfully',
    CREATE_CONSIGNMNET_NOTE: 'Created consignment note successfully',
    UPDATE_CONSIGNMENT_NOTE: 'Updated consignment note successfully',
    DELETE_CONSIGNMENT_NOTE: 'Deleted consignment note successfully',
    CREATE_RATE_SERVICE: 'Updated rate service successfully',
    UPDATE_PACKET_SURCHARGE: 'Updated packet surcharge successfully',
    UPDATE_PACKET_RATE: 'Updated packet rate successfully',
    UPDATE_BOX_RATE: 'Updated box rate successfully',
    UPDATE_PALLET_RATE: 'Updated pallet rate successfully',
    UPDATE_PALLET_SURCHARGE: 'Updated pallet surcharge successfully',
    UPDATE_SAME_DAY_RATE: 'Updated Sameday rate successfully',
    UPDATE_TARIFF_BOX_RATE: 'Updated tariff box rate successfully',
    UPDATE_TARIFF_PACKET_RATE: 'Updated tariff packet rate successfully',
    UPDATE_TARIFF_SAME_DAY_RATE: 'Updated tariff Sameday rate successfully',
    UPDATE_TARIFF_PALLET_RATE: 'Updated tariff pallet rate successfully',
    IMPORT_COUNTRY: 'Imported countries successfully',
    UPDATE_COUNTRY: 'Updated country successfully',
    DELETE_COUNTRY: 'Deleted country successfully',
    IMPORT_ZONE: 'Imported zones successfully',
    CREATE_CHARGE: 'Create consignment charge successfully',
    DELETE_CHARGE: 'Delete consignment charge successfully',
    UPDATE_CHARGE: 'Update consignment charge successfully',

    CREATE_ADDITIONALDROPS: 'Additional Drop created successfully',
    EDIT_ADDITIONALDROPS: 'Additional Drop updated successfully',
    DELETE_ADDITIONALDROPS: 'Additional Drop deleted successfully',

    UPLOAD_LOGO: 'Uploaded logo successfully',
    UPDATE_EXPRESS_SAVER: 'Updated express saver successfully',
    IMPORT_EXPRESS_SAVER: 'Imported express saver successfully',

    IMPORT_EXPRESS: 'Imported express successfully',
    UPDATE_EXPRESS: 'Updated express successfully',

    UPDATE_ROAD_RATE: 'Updated road rate successfully',
    IMPORT_ROAD_RATE: 'Imported road rate successfully',

    UPDATE_EXPEDITED: 'Updated expedited successfully',
    IMPORT_EXPEDITED: 'Imported expedited successfully',

    UPDATE_STANDARD_SINGLE: 'Updated standard single successfully',
    IMPORT_STANDARD_SINGLE: 'Imported standard single successfully',

    UPDATE_STANDARD_MULTI: 'Updated standard multi successfully',
    IMPORT_STANDARD_MULTI: 'Imported standard multi successfully',

    UPDATE_INTERNATIONAL_SURCHARGE: 'Updated international surcharge successfully',
    NEW_SUPPLIER_INVOICE: 'Invoice created successfully',

    SUPPLIER_INVOICE_SEARCH: 'Get supplier invoice search',

    CHANGE_AUTHORISE_INVOICE: 'Invoice authorised',
    POST_TO_XERO: 'Invoice posted to Xero',

    PROCESS_INVOICE: 'Invoice processed',
	ACCEPT_INVOICE: 'Invoice accepted',
	ON_HOLD_INVOICE: 'Update to on hold successfully',
	REVERSE_INVOICE_LEGEND: 'Undo on hold successfully',

    UPDATE_CUSTOMER_SPEND_CONTACT: 'Update Customer Spend successfully',
    CREATE_CUSTOMER_SPEND_CONTACT: 'Create Customer Xero successfully',

    CREATE_POD_ADDITIONAL: 'Created POD successfully',
    UPDATE_POD_ADDITIONAL: 'Updated POD successfully',
    UPDATE_PALLET: 'Update pallet successfully',
  UPDATE_HX_LOAD: 'Re-posted Hx Load successfully',

  CREATE_STANDINGORDER: 'Created standingorder successfully',
  UPDATE_STANDINGORDER: 'Updated standingorder successfully',
  DELETE_STANDINGORDER: 'Deleted standingorder successfully',
  RELEASE_ORDER: 'Released standingorder successfully',

  CREATE_HOLIDAY: 'Created holiday successfully',
  UPDATE_HOLIDAY: 'Updated holiday successfully',
  DELETE_HOLIDAY: 'Deleted holiday successfully',
  DELETE_MONTH_HOLIDAY: 'All the holdays for the selected month deleted successfully',

}

export const ERROR = {
    GOOGLE_API: 'Error google api',
    FILE_IMAGE: 'Please upload only Image',
    SELECT_INVOICE : 'Please select invoice',
    DATE: 'Please selected date',
    CUTTIME: 'You are unable to create consignment because cutoff time',
    SHOW_VIEW_ATTECH: 'There are no attachments on this consignment',
    SUPPLIER_REQUIRE: 'Supplier is required'
}
